import { render } from "./CarIcon.vue?vue&type=template&id=1319c47a"
import script from "./CarIcon.vue?vue&type=script&lang=js"
export * from "./CarIcon.vue?vue&type=script&lang=js"

import exportComponent from "/usr/home/demon/projects/driven/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__